import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NumberInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    shouldAutoFocus: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['formatted_value'],
  setup(__props, { emit }) {

const props = __props;

  
  

  const { convertNumberAnswer } = useCommonMixin()

  const inputRef = ref(null as HTMLInputElement | null)
  const numberInput = ref(props.value)

  watch(numberInput, (value) => {
    numberInput.value = convertNumberAnswer(value)
    emit('formatted_value', numberInput.value)
  })

return { __sfc: true,props, emit, convertNumberAnswer, inputRef, numberInput, ref, watch, useCommonMixin }
}

})